import { VARIANT_DEFAULT, ELEMENT_MODAL, ELEMENT_MENU, ELEMENT_MENU_ITEM, INTERACTION_STATE_OPEN, } from '../../constants';
import { constants as MenuItem } from '../MenuItem';
import { constants as Modal } from '../Modal';
export const constants = Object.freeze({
    NAME: 'Menu',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_MODAL,
        ELEMENT_MENU,
        ELEMENT_MENU_ITEM,
    },
    interactionStates: {
        INTERACTION_STATE_OPEN,
    },
});
export default function getMenu() {
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_MODAL]: {
                components: {
                    [Modal.NAME]: {
                        variant: Modal.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_MENU_ITEM]: {
                components: {
                    [MenuItem.NAME]: {
                        variant: MenuItem.variants.VARIANT_DEFAULT,
                    },
                },
            },
        },
    });
}
